// @ts-nocheck
import { Component } from 'react';
import { ApplyPluginsType } from 'umi';
import dva from 'dva';
// @ts-ignore
import createLoading from '/hdapp/jenkins/agent/test19/workspace/iWMS/iWMS-platform-web-release-test-docker-maven/node_modules/_dva-loading@3.0.25@dva-loading/dist/index.esm.js';
import { plugin, history } from '../core/umiExports';
import ModelArticleItemProcessingConfig0 from '/hdapp/jenkins/agent/test19/workspace/iWMS/iWMS-platform-web-release-test-docker-maven/src/models/config/articleItemProcessingConfig.js';
import ModelAuth1 from '/hdapp/jenkins/agent/test19/workspace/iWMS/iWMS-platform-web-release-test-docker-maven/src/models/config/auth.js';
import ModelDailyConfig2 from '/hdapp/jenkins/agent/test19/workspace/iWMS/iWMS-platform-web-release-test-docker-maven/src/models/config/dailyConfig.js';
import ModelDataSource3 from '/hdapp/jenkins/agent/test19/workspace/iWMS/iWMS-platform-web-release-test-docker-maven/src/models/config/dataSource.js';
import ModelErp4 from '/hdapp/jenkins/agent/test19/workspace/iWMS/iWMS-platform-web-release-test-docker-maven/src/models/config/erp.js';
import ModelSecurity5 from '/hdapp/jenkins/agent/test19/workspace/iWMS/iWMS-platform-web-release-test-docker-maven/src/models/config/security.js';
import ModelDc6 from '/hdapp/jenkins/agent/test19/workspace/iWMS/iWMS-platform-web-release-test-docker-maven/src/models/dc.ts';
import ModelApiconfig7 from '/hdapp/jenkins/agent/test19/workspace/iWMS/iWMS-platform-web-release-test-docker-maven/src/models/down/apiconfig.js';
import ModelApidocs8 from '/hdapp/jenkins/agent/test19/workspace/iWMS/iWMS-platform-web-release-test-docker-maven/src/models/down/apidocs.js';
import ModelApilog9 from '/hdapp/jenkins/agent/test19/workspace/iWMS/iWMS-platform-web-release-test-docker-maven/src/models/down/apilog.js';
import ModelDc10 from '/hdapp/jenkins/agent/test19/workspace/iWMS/iWMS-platform-web-release-test-docker-maven/src/models/down/dc.js';
import ModelDown11 from '/hdapp/jenkins/agent/test19/workspace/iWMS/iWMS-platform-web-release-test-docker-maven/src/models/down/down.js';
import ModelIgnoreStockBinUsageConfig12 from '/hdapp/jenkins/agent/test19/workspace/iWMS/iWMS-platform-web-release-test-docker-maven/src/models/down/ignoreStockBinUsageConfig.js';
import ModelIgnoreUpdate13 from '/hdapp/jenkins/agent/test19/workspace/iWMS/iWMS-platform-web-release-test-docker-maven/src/models/down/ignoreUpdate.js';
import ModelOwner14 from '/hdapp/jenkins/agent/test19/workspace/iWMS/iWMS-platform-web-release-test-docker-maven/src/models/down/owner.js';
import ModelProcessDownloadUpdate15 from '/hdapp/jenkins/agent/test19/workspace/iWMS/iWMS-platform-web-release-test-docker-maven/src/models/down/processDownloadUpdate.js';
import ModelTargetFields16 from '/hdapp/jenkins/agent/test19/workspace/iWMS/iWMS-platform-web-release-test-docker-maven/src/models/down/targetFields.js';
import dvaImmer, { enableES5, enableAllPlugins } from '/hdapp/jenkins/agent/test19/workspace/iWMS/iWMS-platform-web-release-test-docker-maven/node_modules/_dva-immer@0.5.2@dva-immer/dist/index.js';

let app:any = null;

export function _onCreate(options = {}) {
  const runtimeDva = plugin.applyPlugins({
    key: 'dva',
    type: ApplyPluginsType.modify,
    initialValue: {},
  });
  app = dva({
    history,
    
    ...(runtimeDva.config || {}),
    // @ts-ignore
    ...(typeof window !== 'undefined' && window.g_useSSR ? { initialState: window.g_initialProps } : {}),
    ...(options || {}),
  });
  
  app.use(createLoading());
  app.use(dvaImmer());
  (runtimeDva.plugins || []).forEach((plugin:any) => {
    app.use(plugin);
  });
  app.model({ namespace: 'articleItemProcessingConfig', ...ModelArticleItemProcessingConfig0 });
app.model({ namespace: 'auth', ...ModelAuth1 });
app.model({ namespace: 'dailyConfig', ...ModelDailyConfig2 });
app.model({ namespace: 'dataSource', ...ModelDataSource3 });
app.model({ namespace: 'erp', ...ModelErp4 });
app.model({ namespace: 'security', ...ModelSecurity5 });
app.model({ namespace: 'dc', ...ModelDc6 });
app.model({ namespace: 'apiconfig', ...ModelApiconfig7 });
app.model({ namespace: 'apidocs', ...ModelApidocs8 });
app.model({ namespace: 'apilog', ...ModelApilog9 });
app.model({ namespace: 'dc', ...ModelDc10 });
app.model({ namespace: 'down', ...ModelDown11 });
app.model({ namespace: 'ignoreStockBinUsageConfig', ...ModelIgnoreStockBinUsageConfig12 });
app.model({ namespace: 'ignoreUpdate', ...ModelIgnoreUpdate13 });
app.model({ namespace: 'owner', ...ModelOwner14 });
app.model({ namespace: 'processDownloadUpdate', ...ModelProcessDownloadUpdate15 });
app.model({ namespace: 'targetFields', ...ModelTargetFields16 });
  return app;
}

export function getApp() {
  return app;
}

/**
 * whether browser env
 * 
 * @returns boolean
 */
function isBrowser(): boolean {
  return typeof window !== 'undefined' &&
  typeof window.document !== 'undefined' &&
  typeof window.document.createElement !== 'undefined'
}

export class _DvaContainer extends Component {
  constructor(props: any) {
    super(props);
    // run only in client, avoid override server _onCreate()
    if (isBrowser()) {
      _onCreate()
    }
  }

  componentWillUnmount() {
    let app = getApp();
    app._models.forEach((model:any) => {
      app.unmodel(model.namespace);
    });
    app._models = [];
    try {
      // 释放 app，for gc
      // immer 场景 app 是 read-only 的，这里 try catch 一下
      app = null;
    } catch(e) {
      console.error(e);
    }
  }

  render() {
    let app = getApp();
    app.router(() => this.props.children);
    return app.start()();
  }
}
